import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'

export const tab = css`
  flex: 1;
  background-color: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  padding: ${spacing(1.125)} ${spacing(1.5)};
  cursor: pointer;
  border-radius: ${spacing(2.625)};
  transition: all 0.2s ease;
  text-align: center;
  min-height: 33px;
  font-size: 12px;
  font-weight: 500;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
`

export const activeTab = css`
  background-color: #6FCF97;
  color: #1a1a1a;
  font-weight: 600;
  
  &:hover {
    background-color: #6FCF97;
    color: #1a1a1a;
  }
`

export const tabText = css`
  margin: 0;
  font-weight: inherit;
  color: inherit;
`

export const activeTabText = css`
  color: #000000 !important;
` 